import {combineReducers} from 'redux'

import auth from './auth'
import boCore from './boCore';
import topHeader from "./topHeader";
import actionSpinner from './actionSpinner';
import jira from "./jira";
import manageDataBusinessObject from './manageDataBusinessObject';
import savedSearchReducer from './savedSearchReducer';
import lastSearchReducer from './lastSearchReducer';

export default combineReducers({
    auth, boCore, topHeader, manageDataBusinessObject ,actionSpinner, jira, savedSearchReducer, lastSearchReducer
});



// WEBPACK FOOTER //
// ./app/reducers/baseReducer.ts